import React, { useEffect, useRef } from "react";
import "./FindingsDrawer.scss";
import {
  Layout,
  Dropdown,
  Button,
  Divider,
  Input,
  Spin,
  Collapse,
  Card,
  Modal
} from "antd";
import { Tooltip } from "antd";
import Draggable from "../../assets/icons/draggable.svg";
import { setCallingExploreDisplayFiltersDataAPI, setExploreFilterApplyData, setMinimizedOpenedReport } from "../../reducer/PEBCommonSlice";
import { LoadingOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
import FilterIcon from "../../assets/icons/zs-icon-arrow-down.svg";
import ShrinkIcon from "../../assets/icons/Shrink.svg";
import CloseIcon from "../../assets/icons/Close.svg";
import html2canvas from "html2canvas";
import GearIcon from "../../assets/icons/PEB-icon-frame-setting.svg";
import ExpandIcon from "../../assets/icons/icon.svg";
import DownloadIcon from "../../assets/icons/zs-icon-download.svg";
import DownloadDisabledIcon from "../../assets/icons/zs-icon-download-disabled.svg";
import ViewEyeIcon from "../../assets/icons/view-eye-icon.svg";
import ClosedEyeIcon from "../../assets/icons/closed-eye-icon.svg";
import ExcelIcon from "../../assets/icons/excel-icon.svg";
import DocumentIcon from "../../assets/icons/document-icon.svg";
import GearEditIcon from "../../assets/icons/gear-edit-icon.svg";
import EditIcon from "../../assets/icons/edit-pencil-icon.svg";
import aesEncryt from "../../shared/AesEncryt/AesEncryt";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setNavigationTab,
  setIsFindingsReportFullWidth,
  setIsFindingsReportIsOpen,
  setFindingReportAddInsight,
  setFindingsReportAnalysisId,
  setFindingReportData,
  setFindingsReportAnalysisData,
  setHasAccessToReport,
  setDisableData,
  setAnalysisLockFlag,
  setFindingReportContentLength,
  // setRefreshModal1Open, 
  // setRefreshModal2Open, 
  // setDisableReportIndex
} from "../../reducer/PEBCommonSlice";
import ResponseCard from "./ResponseCard";
import InsightsList from "./InsightsList";
import {
  downloadScreenshots,
  getAnalysisData,
  saveFindingsReportData,
} from "../../services/ExperienceBankAPI";
import { useNavigate } from "react-router-dom";

import FindingReportSettingsModal from "../finding-report-setting-modal/FindingReportSettingsModal";
import { useDrop } from "react-dnd";
import AddSupportingInsights from "../add-supporting-insights-modal/AddSupportingInsights";

// import { useRefreshActions } from "../../shared/refreshReportFunctions/useRefreshFunctions";
// YS the code is commented as we don't want to show modal inside

const { Content } = Layout;
const { TextArea } = Input;

const FindingsDrawer = ({
  isClosable,
  isShrinkable,
  isExpandable,
  fullWidth,
}) => {






  //  const {
  //     openFirstModal,
  //     handleFirstModalClick,
  //     handleSecondModalClick,
  //     // refreshExistingReportFn,
  //     // checkStatusUntilSuccess,
  //     // refreshCreateNewExportFn,
  //     getSecondModalContent
  //   } = useRefreshActions();
// const[isCreateExportModalOpen,setIsCreateExportModalOpen] = useState(false);


//   const refreshModal1Open = useSelector((state) => state.PEBCommon?.refreshReport?.refreshModal1Open);
// const refreshModal2Open = useSelector((state) => state.PEBCommon?.refreshReport?.refreshModal2Open);
// // const refreshModal1Action = useSelector((state) => state.PEBCommon?.refreshReport?.refreshModal1Action);
// const refreshModal2Action = useSelector((state) => state.PEBCommon?.refreshReport?.refreshModal2Action);
//   const supportingData = useSelector(
//     (state) => state.PEBCommon?.supportingData
//   );

// const oldAnalysisId = useSelector((state) => state.PEBCommon?.refreshReport?.oldAnalysisId);
// const newAnalysisId = useSelector((state) => state.PEBCommon?.refreshReport?.newAnalysisId);
  // const filterData = useSelector((state) => state.PEBCommon?.filterData);
  //   const recordData = useSelector((state) => state.PEBCommon?.recordData);
  //   const disableReportIndex = useSelector((state)=>state.PEBCommon?.refreshReport.disableReportIndex);
  // const filterExportLibraryCurrentPageData = useSelector((state)=>state.PEBCommon?.refreshReport.filterExportLibraryCurrentPageData);


  // useEffect(()=>{
  //   if(
  //     // (
  //     refreshModal2Action=="refreshExistingExport" 
  //     // || refreshModal2Action=="refreshCreateNewExport" )&& 
  //     // refreshModal1Open==false && refreshModal2Open==false
  //   ){
  //     closeFindingsReport(true);
  //   }
  // },[refreshModal2Action])



  const ins = useSelector(
    (state) => state.PEBCommon?.findingsReport.insight_list
  );

  const addAllClicked = useSelector(
    (state) => state.PEBCommon?.addAllClicked
  );

  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.PEBCommon?.userDetail); // get User details
  const analysisId = useSelector(
    (state) => state.PEBCommon?.findingsReport.analysisId
  );
  const unMappedSupportingData = useSelector(
    (state) => state.PEBCommon?.findingsReport.supporting_data
  );
  const contentLength = useSelector(
    (state) => state.PEBCommon?.findingsReport.contentLength
  );  

  const [editFlag, setEditFlag] = useState(false);
  const [isWordDownloadAllowed,setIsWordDownloadAllowed] = useState(true);

  const [analysisData, setAnalysisData] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const analysisLastData = useSelector(
    (state) => state.PEBCommon?.findingsReport.analysisData
  );
  const [addInsights, setAddInsights] = useState(false);
  const dispatch = useDispatch();
  const isFullWidth = useSelector(
    (state) => state.PEBCommon?.findingsReport.isFullWidth
  );
  const filterAppliedData = useSelector(
    (state) => state.PEBCommon?.exploreFilterApplyData
  );
  // const [newRefreshReportName,setNewRefreshReportName] = useState("");
  // const handleNameChange=(e)=>{
  //   setNewRefreshReportName(e.target.value);
  // }
  
  // console.log("filterData",filterAppliedData);
  
  const [filtersList, setFiltersList] = useState();  
  const [activeKeys, setActiveKeys] = useState([]);
  const [cardInput, setCardInput] = useState("");
  const [showModal,setShowModal] = useState(false);
  const [isInsightBoxOpen,setIsInsightBoxOpen] = useState(true);
  const analysisLockFlagStatus = useSelector((state)=> state.PEBCommon?.analysisLockFlag);
  
  const minimizedOpenedReport = useSelector(
      (state) => state.PEBCommon?.minimizedOpenedReport
    );
  
  const getFindingsReportData = async (payload) => {
    getAnalysisData({
      user_id: userInfo.user_id,
      analysis_id: analysisId || "",
      screen_name: "findings",
      analysis_refresh_date: analysisLastData?.last_updated || "",
      allowed_geographies: userInfo?.allowed_geographies || [],
      allowed_indications:userInfo?.allowed_indications || [],
    }).then(({data,headers}) => {
      const response = data;
      
      dispatch(setExploreFilterApplyData(response.result.filters_data));
      dispatch(setDisableData(response.result.edit_access_flag));
      dispatch(setAnalysisLockFlag(response.result.analysis_lock_flag));
      const sortedInsightList = response.result.insight_mapped_data.sort(
        (a, b) => {
          const aValue = a.insight_sequence;
          const bValue = b.insight_sequence;
          return aValue - bValue;
        }
      );
      let sequence = 1;
      sortedInsightList.forEach((element) => {
        element.questions_list.forEach((question) => {
          question.sequence = sequence;
          sequence++;
        });
      });
      response.result.unmapped_data.forEach((element) => {
        element.sequence = sequence++;
      });

      dispatch(
        setFindingsReportAnalysisData({
          id: analysisId,
          name: response.result.analysis_name,
          description: response.result.analysis_description,
          last_updated: response.result.analysis_refresh_date,
          quesMaxUpdatedTs: response.result.ques_max_updated_ts,
          totalCards:response.result.analysis_total_ques_count
        })
      );
      // dispatch(setHasAccessToReport(response.result.edit_access_flag));

      setAnalysisData({
        name: response.result.analysis_name,
        description: response.result.analysis_description,
        id: analysisId,
      });
      setEditFlag(response.result.edit_access_flag);

      localStorage.setItem(
        "suppCardOrder",
        response.result.analysis_total_ques_count
      );

      // 
      console.log("response.result.unmapped_data,",response.result.unmapped_data,);
      
      dispatch(
        setFindingReportData({
          insight_list: sortedInsightList,
          supporting_data: response.result.unmapped_data,
        })
      );
      dispatch(
        setFindingReportContentLength(
          headers && headers["content-length"]
        )
      )
    });
  };
  useEffect(() => {
    getFindingsReportData();
  }, [isOpen,analysisId,addAllClicked]);

  const panelStyle = {
    marginBottom: 8,
    borderRadius: "2px",
    border: "1px solid #2F9BFF",
  };

  const convertAgeFormat =(ageItem)=>{
   return ageItem.map(group => `${group.age_label} (${group.age_value[0]} years-${group.age_value[1]} years)`)
    .join(', ');
  }

  const convertPrimaryOtherIndication = (data) => {
    let values = [];

    data.forEach((item) => {
      // Add therapeutic_area
      if (item.therapeutic_area) {
        values.push(item.therapeutic_area);
      }

      // Add indications and sub_indications
      item.indication_node.forEach((indication) => {
        if (indication.indication) {
          values.push(indication.indication);
        }
        indication.sub_indication.forEach((subIndication) => {
          values.push(subIndication);
        });
      });
    });

    return values.join(", ");
  };

  const tranformResponseData = (lovMappedIds, lovOptions) => {
    // console.log(lovMappedIds, lovOptions , lovMappedIds[0].length)
    const parentMap = {};
    let result;
    if (lovMappedIds[0]?.includes(" ")) {
      lovOptions.forEach((parent) => {
        const ranks = [];
        parent.children.forEach((child) => {
          if (lovMappedIds.includes(child.value)) {
            ranks.push(child.title.split(" ")[1]); // Extract the rank number
          }
        });

        if (ranks.length > 0) {
          parentMap[parent.title] = ranks;
        }
      });

      // Format the output
      result = Object.entries(parentMap).map(([parentTitle, ranks]) => {
        return `${parentTitle} - Rank (${ranks.join(",")})`;
      });
    } else {
      result = lovMappedIds
        .map((value) => {
          const matchedItem = lovOptions.find((item) => item.value === value);
          return matchedItem
            ? matchedItem.title
            : null;
        })
        .filter(Boolean); // Remove nulls if any unmatched values exist
    }
    // console.log("tranformResponseData ----", result);
    return result.join(", ");
  };

  useEffect(() => {
    let objList = [];
    filterAppliedData?.forEach((item, index) => {
      const obj = {
        key: index + 1,
        style: panelStyle,
        label: (
          <div>
            <strong style={{ color: "#0952CA" }}>
              {analysisLockFlagStatus?item.no_of_respondents:item.no_of_respondents_insights}:{" "}
            </strong>
            <span className="catDescp">{item.comparator_name}</span>
          </div>
        ),
        children: (
          <Row className="row-col" style={{ background: "#F8FCFF" }}>
            {!item.is_empty_comparator && (
              <Col span={24} style={{ marginTop: 8 }}>
                <strong className="cf-label3">Definition</strong>
              </Col>
            )}
            {item.primary_indication?.length > 0 && !analysisLockFlagStatus && (
              <Col span={24}>
                <strong className="cf-label">Primary Indication: </strong>
                <span className="cf-label2">
                  {convertPrimaryOtherIndication(item.primary_indication)}
                </span>
              </Col>
            )}
            {item.other_indication?.length > 0 && !analysisLockFlagStatus && (
              <Col span={24}>
                <strong className="cf-label">Other Indication: </strong>
                <span className="cf-label2">
                  {convertPrimaryOtherIndication(item.other_indication)}
                </span>
              </Col>
            )}
            {item?.stage?.length > 0 && (
              <Col span={24}>
                <strong className="cf-label">
                  Cancer Stage at Diagnosis:{" "}
                </strong>
                <span className="cf-label2">{item.stage.toString()}</span>
              </Col>
            )}
            {item.therapeutic_area.length > 0 && analysisLockFlagStatus && (
              <Col span={24}>
                <strong className="cf-label">Therapy Area: </strong>
                <span className="cf-label2">
                  {item.therapeutic_area.toString()}
                </span>
              </Col>
            )}
            {item.indication.length > 0 && analysisLockFlagStatus && (
              <Col span={24}>
                <strong className="cf-label">Indication: </strong>
                <span className="cf-label2">{item.indication.toString()}</span>
              </Col>
            )}
            {item.sub_indication.length > 0 && analysisLockFlagStatus && (
              <Col span={24}>
                <strong className="cf-label">Sub-Indication: </strong>
                <span className="cf-label2">
                  {item.sub_indication.toString()}
                </span>
              </Col>
            )}
             {/* custom_region */}
              {item.custom_region.length > 0 && item.custom_region[0]!="All" && (
              <Col span={24}>
                <strong className="cf-label">Geography: </strong>
                <span className="cf-label2">{item.custom_region.toString()}</span>
              </Col>
            )}
             {item.region.length > 0 && (
              <Col span={24}>
                <strong className="cf-label">Region: </strong>
                <span className="cf-label2">{item.region.toString()}</span>
              </Col>
            )}
             {/* {item.geo_state_mapped_data?.length > 0 && !analysisLockFlagStatus && (
              <Col span={24}>
                <strong className="cf-label">Country: </strong>
                <span className="cf-label2">
                  {item.geo_state_mapped_data.join(', ')}
                </span>
              </Col>
            )} */}
            {/* {item.geo_state_mapped_data?.length > 0 && !analysisLockFlagStatus && (
              <Col span={24}>
                <strong className="cf-label">Country: </strong>
                <span className="cf-label2">
                  {item.geo_state_mapped_data
                    .map(country => 
                      country.includes('__') ? country.split('__')[1] : country
                    )
                    .join(', ')
                  }
                </span>
              </Col>
            )} */}
             {item.geo_state?.length > 0 && !analysisLockFlagStatus && (
              <Col span={24}>
                <strong className="cf-label">Country: </strong>
               
                <span className="cf-label2">
                  {item.geo_state.map((data, index) => 
                    `${data?.geography}${data?.state?.length ? ` (${data.state.join(', ')})` : ''}${index !== item.geo_state.length - 1 ? ', ' : ''}`
                  )}
                  {/* {item.geo_state.map((data, index) => {
                    // Function to decode Unicode escape sequences
                    const decodeUnicode = (str) => {
                      if (!str || typeof str !== 'string') return str;
                      return str.replace(/u([0-9a-fA-F]{4})/g, (match, code) => {
                        return String.fromCharCode(parseInt(code, 16));
                      });
                    };

                    const decodedGeography = decodeUnicode(data?.geography || '');
                    const decodedStates = data?.state?.map(state => decodeUnicode(state || ''));

                    return `${decodedGeography}${decodedStates?.length ? ` (${decodedStates.join(', ')})` : ''}${index !== item.geo_state.length - 1 ? ', ' : ''}`;
                  })} */}
                </span>
              </Col>
            )}
            {item.geography.length > 0 && (
              <Col span={24}>
                <strong className="cf-label">Geography: </strong>
                <span className="cf-label2">{item.geography.toString()}</span>
              </Col>
            )}
            {item.race.length > 0 && (
              <Col span={24}>
                <strong className="cf-label">Race: </strong>
                <span className="cf-label2">{item.race.toString()}</span>
              </Col>
            )}
            {item.ethnicity.length > 0 && (
              <Col span={24}>
                <strong className="cf-label">Ethnicity: </strong>
                <span className="cf-label2">{item.ethnicity.toString()}</span>
              </Col>
            )}
            {item.origin_country.length > 0 && (
              <Col span={24}>
                <strong className="cf-label">Country of Origin: </strong>
                <span className="cf-label2">
                  {item.origin_country.toString()}
                </span>
              </Col>
            )}
            {item.age.length > 0 && (
              <Col span={24}>
                <strong className="cf-label">Age: </strong>
                <span className="cf-label2">{convertAgeFormat(item.age)}</span>
              </Col>
            )}
            {item.gender.length > 0 && (
              <Col span={24}>
                <strong className="cf-label">Sex at Birth: </strong>
                <span className="cf-label2">{item.gender.toString()}</span>
              </Col>
            )}
            {item?.year_range?.length > 0 && (
              <Col span={24}>
                <strong className="cf-label">Time Period: </strong>
                <span className="cf-label2">{item.year_range.toString()}</span>
              </Col>
            )}
            {item?.category?.length > 0 && (
              <Col span={24}>
                <strong className="cf-label">Insight Category: </strong>
                <span className="cf-label2">{item.category.toString()}</span>
              </Col>
            )}
            {item?.ques_alias?.length > 0 && (
              <Col span={24}>
                <strong className="cf-label">Qualifying Question: </strong>
                <span className="cf-label2">{item.ques_alias.toString()}</span>
              </Col>
            )}
            {item?.lov_id_mapped_data?.length > 0 && (
              <Col span={24}>
                <strong className="cf-label">Qualifying Response: </strong>
                {/* <span className="cf-label2">{item.lov_id_mapped_data.toString()}</span> */}
                <span className="cf-label2">
                  {tranformResponseData(
                    item.lov_id_mapped_data,
                    item.lov_id_options
                  )}
                </span>
              </Col>
            )}
          </Row>
        ),
      };
      objList.push(obj);
    });
    setFiltersList(objList);
  }, [filterAppliedData]);

  const onChange = (key) => {
    setActiveKeys(key);
  };

  const handleInputChange = (e) => {
    setCardInput(e.target.value);
  };

  const addInsight = async (data) => {
    const payload = {
      user_id: userInfo.user_id,
      analysis_id: analysisId,
      save_type: "only_insight",
      order_data: {},
      prev_insight_id: "",
      insight_id: "",
      insight_text: data.insight_text,
      ques_id: "",
      insight_order: data.insight_order,
      ques_order: 10,
      supporting_data: "",
      preference: "",
      reason: "",
      supp_card_id: "",
      supp_card_order: 6,
      combined_indication:""
    };
    let response = await saveFindingsReportData(payload);
    return response.result;
  };
  const handleAddCard = (settingshowModal=false) => {
    if (cardInput.trim() !== "") {
      const new_insight = {
        insight_order: ins.length + 1,

        questions_list: [],
        analysis_name: "analysis_nm_465",
        insight_text: cardInput || "",
        insight_id: "", // Initialize it as an empty string
      };

      // Call the addInsight function to save the insight
      addInsight(new_insight)
        .then((response) => {
          setAddInsights(false);
          new_insight.insight_id = response.insight_id;
          dispatch(setFindingReportAddInsight(new_insight));
          if(settingshowModal)
            setShowModal(true);
        })
        .catch((error) => {
          ///useNotifications
        })
        .finally(() => setCardInput(""));

      // Dispatch the updated new_insight

      // Reset the cardInput
    }
    if (cardInput.trim() == "") setAddInsights(false);
  };
//
  const downloadWordDocument = () => {

    let cardLength = 0;
    cardLength = cardLength + unMappedSupportingData?.length;
    let insightsLength =  0;
    ins.map((item)=>{
      insightsLength+= item?.questions_list?.length;
    });
    cardLength+=insightsLength;
    
    if(cardLength<=50){
      if (isFullWidth) {
        takeScreenshot();
      } else {
        dispatch(setIsFindingsReportFullWidth(true));
        setTimeout(() => {
          takeScreenshot();
        }, 1000);
      }
    }
    else{
      setIsWordDownloadAllowed(false);
    }
    
  };

  const [flag, setFlag] = useState(false);

  const takeScreenshot = async () => {
    setFlag(true);
  
    const fetchImageBase64 = async (elementId) => {
      return new Promise((resolve, reject) => {
        let element = document.getElementById(elementId);
        if (element) {
          html2canvas(element).then((canvas) => {
            canvas.toBlob((blob) => {
              const reader = new FileReader();
              reader.onloadend = function () {
                const base64data = reader.result;
                resolve(base64data);
              };
              reader.readAsDataURL(blob);
            });
          });
        } else {
          reject("Element not found");
        }
        element = null;
      });
    };
  
    const processChunks = async (data, processChunkFn) => {
      const chunkSize = 10; // Process 10 items at a time
      let index = 0;
      let allProcessedImages = [];
  
      while (index < data.length) {
        const chunk = data.slice(index, index + chunkSize);
        const chunkPromises = chunk.map((item, index) => processChunkFn(item, index));
  
        // Wait for the chunk to be processed
        const chunkImages = await Promise.all(chunkPromises);
        allProcessedImages = [...allProcessedImages, ...chunkImages];
        index += chunkSize;
      }
      return allProcessedImages;
    };
  
    const download = async () => {
      try {
        let insightsDataImages = await processChunks(ins, (item, index) =>
          fetchImageBase64("question-Card" + index)
        );
        
        let supportingQuesImages = await processChunks(unMappedSupportingData, (item, index) =>
          fetchImageBase64(item.supp_card_id)
        );

        // Process base64 data and prepare for Word file generation
        let insightsDataList = insightsDataImages.map(
          (image) => image.split("data:image/png;base64,")[1]
        );
        
        let supportingQuesList = supportingQuesImages.map(
          (image) => image.split("data:image/png;base64,")[1]
        );        
  
        const pocPayload = {
          user_id: userInfo.user_id,
          screen_name: "finding",
          analysis_id: analysisId,
          insights_data_list: insightsDataList,
          supporting_ques_list: supportingQuesList,
          export_type: "word",
          filters_data: filterAppliedData,
          analysis_lock_flag: analysisLockFlagStatus,
        };
        const response = await downloadScreenshots(pocPayload);
        window.open(aesEncryt(response?.export_url), "_parent");
  
        // Cleanup
        insightsDataImages.length = 0; // Clear memory
        supportingQuesImages.length = 0; // Clear memory
        insightsDataList.length = 0; // Clear memory
        supportingQuesList.length = 0; // Clear memory        
             
        setFlag(false);
      } catch (error) {
        console.error("Error:", error);
        setFlag(false);
      }
    };
    download();
  };

  const downloadExcelDocument = async () => {
    try {
      setFlag(true);
      const pocPayload = {
        user_id: userInfo.user_id,
        screen_name: "finding",
        analysis_id: analysisId,
        insights_data_list: [],
        supporting_ques_list: [],
        export_type: "excel",
        filters_data: filterAppliedData,
        analysis_lock_flag: analysisLockFlagStatus,
      };
      const response = await downloadScreenshots(pocPayload);
      setFlag(false);
      window.open(aesEncryt(response.export_url), "_parent");
    } catch (error) {}
  };

  const closeFindingsReport = (flag) => {
    dispatch(setIsFindingsReportIsOpen(false));
    dispatch(setIsFindingsReportFullWidth(false));
    dispatch(setFindingReportData({ insight_list: [], supporting_data: [] }));
    dispatch(setFindingsReportAnalysisId(null));
    dispatch(setFindingsReportAnalysisData({}));
    dispatch(setHasAccessToReport(true));
    dispatch(setDisableData(false));
    dispatch(setAnalysisLockFlag(false));
    if (flag) navigate("/analysis-library");
    else {
      navigate("/explore");
    }
    localStorage.removeItem("suppCardOrder");
    localStorage.removeItem("analysisId");
  };
  const openAddFindingsModal = () => {
    // dispatch(setFindingsReportAddToFindingsModal(true))
    setIsOpen(true);
  };
  const viewAllFindings = () => {
    // dispatch(setIsFindingsReportIsOpen(false));
    closeFindingsReport(true);
    dispatch(setNavigationTab("/analysis-library"));
  };

  const items = [
    {
      label: "Edit Settings",
      key: "edit-setting",
      onClick: openAddFindingsModal,
    },
    // {
    //   label: "View All Findings Export",
    //   key: "view-all",
    //   onClick: viewAllFindings,
    // },
    {
      label: "Close Export",
      key: "close-report",
      onClick: () => (closeFindingsReport(false)
          ,dispatch(setCallingExploreDisplayFiltersDataAPI(true))
      
    ),
    },
  ];
  const items2 = [
    {
      label: editFlag ? "Edit Settings" : "View Settings",
      key: "edit-setting",
      onClick: openAddFindingsModal,
    },
    {
      label: "View All Findings Export",
      key: "view-all",
      onClick: viewAllFindings,
    },
  ];
  const downloadOptions = [
    {
      label: "Download Excel Document",
      key: "word-document",
      onClick: downloadExcelDocument,
      icon: (
        <img
          src={ExcelIcon}
          alt="open-icon"
          style={{ cursor: "pointer", marginRight: 5 }}
        />
      ),
    },
    {
      label: "Download Word Document from full screen mode",
      key: "excel-document",
      onClick: downloadWordDocument,
      icon: (
        <img
          src={DocumentIcon}
          alt="open-icon"
          style={{ cursor: "pointer", marginRight: 5 }}
        />
      ),
    },
  ];
  const antIcon = <LoadingOutlined style={{
    // background:'green',
    fontSize:'30px',
    marginTop:'-50px'}} spin />;

  const renderCard = (card, index) => {
    if (!card) return;

    const cards = card.supporting_data;
    return (
      <ResponseCard
        editAccessFlag={editFlag}
        supp_card_order={card.supp_card_order}
        supp_card_id={card.supp_card_id}
        key={card.ques_id}
        index={index}
        id={cards.ques_id}
        sequence={card.sequence}
        // moveCard = {moveCard}
        reason={Array.isArray(card.reason) ? card.reason : [card.reason] || []}
        ques_order={card.ques_order}
        setIsResponseCardDragging={setIsResponseCardDragging}
        isResponseCardDragging={isResponseCardDragging}
        unMappedSupportingData={cards}
      />
    );
  };
  const [isResponseCardDragging, setIsResponseCardDragging] = useState(false);

  const renderInsights = (insights, index) => {
    return (
      <InsightsList
        editAccessFlag={editFlag}
        insights={insights}
        key={index}
        id={insights.insight_id}
        index={index}
        dragFlag={isResponseCardDragging}
        setIsResponseCardDragging={setIsResponseCardDraggingFunction}
        isResponseCardDragging={isResponseCardDragging}
        analysisData={analysisData}
      />
    );
  };
  useEffect(() => {}, []);
  const setIsResponseCardDraggingFunction = (value) => {
    setIsResponseCardDragging(value);
  };
  const inputRef = useRef();

  const containerRef = useRef();
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
       // Prevent submission if input is empty or only whitespace
      if (!cardInput.trim()) {
        e.preventDefault();
        return;
      }
      // setIsActive(false);
      setAddInsights(false);
      handleAddCard();
    }
  };
  const handleBlur = () => {
    handleAddCard();
  };
  const [, drop] = useDrop(
    () => ({
      accept: "response",
      // canDrop: editAccessFlag,

      drop: (_item) => {
        if (!_item.insight_id) return;
        addSupportingDataToUnmappedData(
          _item.insight_id,
          _item.supp_card_id
        ).then(() => getFindingsReportData());
      },
    }),
    [ins]
  );
  const addSupportingDataToUnmappedData = async (
    insight_id,
    supp_card_id,
    supp_card_order
  ) => {
    const payload = {
      user_id: userInfo.user_id,
      analysis_id: analysisId,
      save_type: "supp_ques",
      order_data: {},
      prev_insight_id: "",
      insight_id: insight_id,
      insight_text: "",
      ques_id: "",
      insight_order: 1,
      ques_order: 0,
      supporting_data: "",
      move_from_insight_to_unmapped: true,
      preference: "",
      reason: "",
      supp_card_id: supp_card_id,
      supp_card_order: 0,
      combined_indication:"",
    };

    let response = await saveFindingsReportData(payload);
    return response;
  };
  const ISCARDSELECTED = useSelector(
    (state) => state.PEBCommon.findingsReport.selectedCard
  );
  const supportingCardArea = useRef(null);
  drop(supportingCardArea);

  const goTOExplore = () => {
    dispatch(setIsFindingsReportFullWidth(false));
    navigate("/explore", { state: { tabValue: "2" } });
  };
  //  const getModalFooter = () => {
  //     if (refreshModal2Action === "refreshCreateNewExport") {
  //       return [
  //         <Button
  //           key="submitUpdate"
  //           type="primary"
  //           onClick={() => handleSecondModalClick("refreshSubmitNewName",newRefreshReportName,filterExportLibraryCurrentPageData[disableReportIndex])}
  //         >
  //           Submit
  //         </Button>
  //       ];
  //     }
    
  //     return [
  //       <Button
  //         disabled={
  //           userInfo.user_email !== filterExportLibraryCurrentPageData[disableReportIndex]?.created_by_email_id ||
  //           filterExportLibraryCurrentPageData[disableReportIndex]?.analysis_lock_flag
  //         }
  //         key="refreshExistingExport"
  //         onClick={() => handleSecondModalClick("refreshExistingExport","",filterExportLibraryCurrentPageData[disableReportIndex])}
  //       >
  //         Refresh Existing Export
  //       </Button>,
  //       <Button
  //         key="refreshCreateNewExport"
  //         type="primary"
  //         onClick={() => {
  //           handleSecondModalClick("refreshCreateNewExport","",filterExportLibraryCurrentPageData[disableReportIndex]);
  //           // setIsCreateExportModalOpen(true);
  //         }}
  //       >
  //         Create New Export
  //       </Button>
  //     ];
  //   };
    // return (<></>)

    const expandedHeight = 'calc(100vh - 56px)';
    const minimizedHeight = '55px';

    const containerStyle = {
      height: minimizedOpenedReport ? minimizedHeight : expandedHeight,
      overflowY: minimizedOpenedReport ? 'hidden' : 'auto',
      position: minimizedOpenedReport ? 'relative' : 'sticky',
      top: minimizedOpenedReport ? '' : 56,
      width: '100%',
      // marginTop: minimizedOpenedReport ? '210px' : '',
      transition: 'height 0.3s ease , margin-top 0.3s',
    };




  return (
    <Layout
      className={minimizedOpenedReport?"":"your-component"}
      style={
        isFullWidth
          ?
          {
            top: 0,
            position: "sticky",
            overflowY: "auto",
            height: "calc(100vh - 56px)",
            // bottom: 10,
          }:containerStyle
      }>








         {/* {isCreateExportModalOpen && (
        <FindingReportSettingsModal
          isOpen={isCreateExportModalOpen}
          setIsOpen={setIsCreateExportModalOpen}
          supporting_data={supportingData}
          filterData={filterData}
          recordData={recordData}
          type={"category_responses"}
          addFlag={false}
          createAddFlag={true}
        />
      )} */}

           {/* <Modal
              title="First Modal"
              open={refreshModal1Open}
              onCancel={() => (dispatch(setRefreshModal1Open(false)) )}
              footer={[
                <Button key="refreshData" onClick={() => handleFirstModalClick('refreshData')}>
                  Refresh Data
                </Button>,
                <Button key="refreshUpdateCriteria" type="primary" onClick={() => handleFirstModalClick('refreshUpdateCriteria')}>
                  Update Criteria
                </Button>,
              ]}
            >
              <p><strong>How would you like to refresh the report?
              </strong></p>
              <p>Would you prefer to refresh the report with the latest data, or refresh the report using new criteria/target population?</p>
                    
            </Modal> */}
      
            {/* <Modal
              title="Second Modal"
              open={refreshModal2Open}
              onCancel={()=> (dispatch(setRefreshModal2Open(false)))}
              // footer={[
              //   <Button key="close" onClick={handleSecondModalClick}>
              //     Close
              //   </Button>,
              // ]}
      
      
              // footer={[
              //   <Button  
              //   disabled={(userInfo.user_email != filterExportLibraryCurrentPageData[disableReportIndex]?.created_by_email_id) ||
              //     filterExportLibraryCurrentPageData[disableReportIndex]?.analysis_lock_flag}  
                  
              //     key="refreshExistingExport" onClick={() => handleSecondModalClick('refreshExistingExport')}>
              //     Refresh Existing Export
              //   </Button>,
              //   <Button key="refreshCreateNewExport" type="primary" onClick={() => (handleSecondModalClick('refreshCreateNewExport'),setIsCreateExportModalOpen(true))}>
              //     Create New Export
              //   </Button>,
              // ]}
              footer={getModalFooter()}

            >
              {getSecondModalContent()}
              <p><strong>Do you want to refresh the existing report or create a new one?  </strong></p>
              {refreshModal2Action=="refreshCreateNewExport"?(
                        // <button>Name input</button>
                         <Input
                            size="large"
                            placeholder="Enter Report Name"
                            title={
                              // category.selectAll
                              //   ? "All"
                              //   : category.selectedValue?.join(", ")
                              "Title"
                            }
                            style={{ width: "100%" }}
                            value={
                              // category.selectAll
                              //   ? "All"
                              //   : category.selectedValue?.join(", ")
                              newRefreshReportName
                            }
                            allowClear
                            onChange={(e)=>handleNameChange(e)}
                            // suffix={<DownOutlined />}
                          />
                      ):(
                        <></>
                      )}
            </Modal>
       */}














      {isOpen && (
        <FindingReportSettingsModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          analysisID={analysisId}
          addFlag={false}
        />
      )}
      {!isWordDownloadAllowed && (
      <Modal
        closable={false}
        maskClosable={false}
        open={true}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={()=>setIsWordDownloadAllowed(true)}
            style={{ backgroundColor: "#27A6A4" }}>
            OK
          </Button>,
        ]}>
        <p><strong>To ensure smooth downloading, Word export is limited to 50 cards.
        </strong></p>
        <p><strong>For larger exports, Excel is recommended.</strong></p>

      </Modal>
    )}
      <Spin 
        tip={
          addAllClicked ? (
              <>
                  <div>Addition to Export in Progress - </div>
                  <div 
                  // style={{ marginBottom:'5px' }}
                  >
                      {/* ( This might take a few seconds ) */}
                      Please wait till the current process is completed
                  </div>
              </>
          ) : (
              "Processing your request... Your export will be ready soon."
          )
      }
        indicator={antIcon} 
        spinning={flag||addAllClicked}
        style={addAllClicked?{
          // position: 'fixed', 
          // top: '9%', 
          // left: '37%',
          background:'#F5F5F5',
          // background:'red',
          opacity:'0.95',
          height:'160px',
          // paddingBottom:'50px',
          // marginTop:'auto',
          // margin:'auto',
          position: 'fixed',
          // top:'19%',
          top: '111px',
          // left: '800px',
          left: '73.8%',
          // right: '1.5%',
          right:'16px',
          width: '-webkit-fill-available',
          // background: 'red',
          ...(isFullWidth && {
            // background: 'red',
            opacity: 0.95,
            height: '190px',
            position: 'fixed',
            top: '32%',
            marginTop: '-33px',
            bottom: '32%',
            // display: 'flex', // uncomment if needed
            left: '32%',
            right: '32%',
            // right: '16px', // optional alternative
            // width: '-webkit-fill-available',
            // border: '1px solid black',
            // margin: 'auto'
          })
         
        }:{
          // styles for word file download
          // position: 'fixed',
        }}
        
        >
        <div
          className="row"
          style={{ position: "sticky", top: 0, zIndex: 1000 }}>
          <h1 style={{ width: "fit-content" }}>{analysisData.name}</h1>
          {!isClosable ? (
            isExpandable ? (
              <Dropdown
                menu={{ items: items, selectable: false }}
                trigger={["click"]}
                overlayStyle={{ width: 200, borderRadius: "0px" }}>
                <img
                  src={FilterIcon}
                  alt="filter-icon"
                  style={{ cursor: "pointer" }}
                />
              </Dropdown>
            ) : (
              <>
                <Tooltip placement="top" title={"Export Details"}>             
                  <img
                    style={{
                      cursor: "pointer",
                    }}
                    src={GearEditIcon}
                    alt="download-icon"
                    onClick={() => {
                      openAddFindingsModal();
                    }}
                  />
                </Tooltip>
                <Tooltip placement="top" title={"Edit Export"}>  
                <img
                  style={{
                    cursor: "pointer",
                  }}
                  src={EditIcon}
                  alt="edit-icon"
                  onClick={() => {
                    // setFullWidth(false);
                    dispatch(setIsFindingsReportFullWidth(false));
                  }}
                />
                </Tooltip>
              </>
            )
          ) : (
            <>
             <Tooltip placement="top" title={"Export Details"}>    
              <img
                style={{
                  cursor: "pointer",
                }}
                src={GearEditIcon}
                alt="download-icon"
                onClick={() => {
                  openAddFindingsModal();
                }}
              />
               </Tooltip>
                <Tooltip placement="top" title={"Edit Export"}>  
              {analysisLockFlagStatus ? (
                <img
                  alt={"Edit Disabled"}
                  style={{ cursor: "auto" , opacity: '0.5' }}
                  src={EditIcon}
                />
              ) : (
                <img
                  style={{
                    cursor: "pointer",
                  }}
                  src={EditIcon}
                  alt="edit-icon"
                  onClick={() => {
                    // setFullWidth(false);
                    goTOExplore();
                  }}
                />
              )}
              </Tooltip>
            </>
          )}
          <Tooltip placement="top" title={"Download Export"}>  
          <Dropdown
            menu={{ items: downloadOptions }}
            trigger={["click"]}
            overlayStyle={{ width: 240, borderRadius: "0px" }}>
            <img
              style={{
                cursor: "pointer",
              }}
              src={DownloadIcon}
              alt="download-icon"
            />
          
          </Dropdown>
          </Tooltip>
           {/* <Button 
                // disabled={(userInfo.user_email != item.created_by_email_id) ||
                //       item.analysis_lock_flag} 
                type="primary" 
                onClick={()=>openFirstModal(disableReportIndex,filterExportLibraryCurrentPageData[disableReportIndex]?.analysis_id)}
            >
              Open First Modal {filterExportLibraryCurrentPageData[disableReportIndex]?.analysis_id}
            </Button> */}
          {/* <button>hi</button> */}
          {isExpandable && (
            <img
              src={ExpandIcon}
              style={{ cursor: "pointer" }}
              alt="expand-icon"
              onClick={() => {
                // setFullWidth(true);
                dispatch(setIsFindingsReportFullWidth(true));
              }}
            />
          )}
          {!isExpandable && (
            <img
              src={CloseIcon}
              style={{ cursor: "pointer", marginLeft: "auto" }}
              alt="close-icon"
              onClick={() => {
                closeFindingsReport(isClosable ? true : false);
              }}
            />
          )}

          {isExpandable && (
            // <img
            //   src={CloseIcon}
            //   style={{ cursor: "pointer", marginLeft: "auto" }}
            //   alt="close-icon"
            //   onClick={() => {
            //     closeFindingsReport(isClosable ? true : false);
            //   }}
            // />
            <>

            <Button 
            type="primary"
            style={{ cursor: "pointer", marginLeft: "auto" }} 
            onClick={()=>(dispatch(setMinimizedOpenedReport(!minimizedOpenedReport))
            // ,alert("clicked")
            )} >{minimizedOpenedReport?"Expand":"Minimize"}
            </Button>
            </>
          )}
        </div>
        {/* have to hide this */}
        <Content
          style={{
            textAlign: "left",
            padding: "24px",
            background: "#FAFAFA",
          }}
          ref={containerRef}>
          <Row gutter={[16, 16]}>
            <>
              <Col span={24}>
                <strong>Description: </strong>
                {analysisData.description}
              </Col>

              <Col className="target-population-style" span={24}>
                <Collapse
                  activeKey={activeKeys}
                  collapsible="header"
                  onChange={onChange}
                  items={[
                    {
                      key: "1",
                      label: (
                        <div>
                          <strong>{filterAppliedData?.length} </strong>
                          <span className="catDesc">
                            Target Populations in Export
                          </span>
                          {isFullWidth ? (
                            activeKeys.length === 0 ? (
                              <span className="view-close-label">
                                <Divider
                                  type="vertical"
                                  style={{ height: "2em", marginLeft: 24 }}
                                />
                                <img
                                  src={ViewEyeIcon}
                                  alt="open-icon"
                                  style={{ cursor: "pointer", marginRight: 5 }}
                                />
                                View Definitions
                              </span>
                            ) : (
                              <span className="view-close-label">
                                <Divider
                                  type="vertical"
                                  style={{ height: "2em", marginLeft: 24 }}
                                />
                                <img
                                  src={ClosedEyeIcon}
                                  alt="close-icon"
                                  style={{ cursor: "pointer", marginRight: 5 }}
                                />
                                Close Definitions
                              </span>
                            )
                          ) : (
                            ""
                          )}
                        </div>
                      ),
                      children: (
                        <>
                          {!isFullWidth ? (
                            <div
                              className="div-collapse"
                              style={{ padding: 8 }}>
                              <Collapse
                                items={filtersList}
                                collapsible="header"></Collapse>
                            </div>
                          ) : (
                            <Row gutter={16} style={{ padding: 10 }}>
                              {filtersList
                                ? filtersList?.map((item,i) => (
                                    <Col
                                      className="trgt-pop-fullscreen"
                                      key={i}
                                      span={8}>                      
                                      <Card title={item.label} bordered={false}>
                                        {item.children}
                                      </Card>
                                    </Col>
                                  ))
                                : ""}
                            </Row>
                          )}
                        </>
                      ),
                    },
                  ]}
                />
              </Col>
              {editFlag && (
                <Col span={24}>
                  <Button
                    onClick={() => {
                      setAddInsights(true);
                      setIsInsightBoxOpen(true);
                    }}>
                    + Add Comment
                  </Button>
                </Col>
              )}
            </>

        {addInsights && editFlag && isInsightBoxOpen && (
          <Col span={24} className="">
            <Col
              span={24}
              className="drag-header"
              gutter={[8, 8]}
              style={{ background: "#DEDCDE", cursor: "move", position: "relative" }}>
              <img src={Draggable} alt="draggable" />
              
              {/* Close button */}
              <div 
                style={{
                  position: 'absolute',
                  top: '2px',
                  right: '8px',
                  width: '22px',
                  height: '22px',
                  backgroundColor: '#fff',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  color: '#666',
                  zIndex: 10
                }}
                onClick={() => {
                  setIsInsightBoxOpen(false);
                  // Add your close logic here
                  // For example: setAddInsights(false) or setEditFlag(false)
                }}
              >
                ×
              </div>
            </Col>
            <Col
              span={24}
              className={" question-card question-drag-add "}
              style={{ padding: 12 }}>
              
              {/* Container for the integrated layout */}
              <div style={{ position: 'relative' }}>
                {/* TextArea taking full width */}
                <TextArea
                  rows={4}
                  type="text"
                  autoFocus
                  value={cardInput}
                  placeholder="Please Enter the Category Name"
                  onChange={handleInputChange}
                  ref={inputRef}
                  onKeyDown={handleKeyDown}
                  // disabling the functiona;lity 
                  // insight save on clicking outside
                  // onBlur={() => {
                  //   handleBlur();
                  // }}
                  className={isFullWidth ? "large-placeholder":""}
                  style={{ 
                    width: '100%',
                    paddingRight: isFullWidth ? '50%' : '0' // Only add padding when fullWidth
                  }}
                />
                
                {/* Overlay box - positioned based on isFullWidth */}
                <div style={{
                  position: isFullWidth ? 'absolute' : 'relative',
                  top: isFullWidth ? '8px' : '8px',
                  right: isFullWidth ? '8px' : '0',
                  width: isFullWidth ? 'calc(46% - 6px)' : '100%',
                  height: isFullWidth ? 'calc(98% - 16px)' : 'auto',
                  minHeight: !isFullWidth ? '60px' : 'auto',
                  border: '1px solid #d9d9d9',
                  borderRadius: '4px',
                  backgroundColor: '#fafafa',
                  padding: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: `${cardInput ? 'pointer' : 'not-allowed'}`,
                  pointerEvents: `${cardInput ? 'visible' : 'none'}`,
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                  marginTop: !isFullWidth ? '8px' : '0' // Add margin when below textarea
                }}>
                  <div style={{ 
                    textAlign: 'center',
                    color: '#666',
                    fontSize: isFullWidth ? '17px' : '14px', // Smaller font when below
                    cursor: 'pointer',
                    lineHeight: '1.4'
                  }}
                  onClick={()=>(
                    handleAddCard(true)
                    // setTimeout(() => {
                    //    setShowModal(true)
                    // }, 500)
                  )}
                  >
                    Add a supporting insight by{" "}
                    <span style={{ color: "#27a6a4" }}>
                      selecting this area
                    </span>{" "}
                    or dragging the cards.
                  </div>
                </div>
              </div>
              
            </Col>
          </Col>
        )}
            <Col span={24}>
              {ins.map((insight, index) => (
                <React.Fragment key={index}>
                  {" "}
                  {renderInsights(insight, index)}
                </React.Fragment>
              ))}
            </Col>
            <Divider style={{ margin: "4px", border: "1px solid #9C9AA1" }} />

            <Row
              gutter={[16, 16]}
              align="top"
              ref={supportingCardArea}
              style={{ width: "100%" }}>
              {ISCARDSELECTED && (
                <Col
                  span={24}
                  style={{ padding: 16 }}
                  className="unmapped_data">
                  Drag in supporting Area
                </Col>
              )}

              {unMappedSupportingData.length > 0 &&
                unMappedSupportingData.map((card, i) => (
                  <Col
                    span={isFullWidth ? 12 : 24}
                    key={i}
                    style={{
                      padding: "0 8px",
                      // display: "flex",
                    }}
                    className="response">
                    {renderCard(card, i)}
                  </Col>
                ))}
            </Row>
          </Row>
        </Content>
         {showModal && (
        <div>
          <AddSupportingInsights
            visible={true}
            insightDetails={ins[ins?.length-1]}
            analysisData={analysisData}
            unMappedSupportingData={unMappedSupportingData}
            onClose={() => setShowModal(false)}
          />
        </div>
      )}
      </Spin>
    </Layout>
  );
} ;

export default FindingsDrawer;
